// Core imports
import * as React from 'react';
import MUIDataTable from 'mui-datatables';
import theme from '../../../themes/samsung_MUI_themes';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CustomPaginator from '../../common/CustomPaginator';
import Fade from '@material-ui/core/Fade';
import i18n from 'src/translation/i18n';
import Button from '@material-ui/core/Button';
import downloadReceipt from 'src/assets/downloadReceipt';
import downarrowIcon from 'src/assets/downArrow';
import { IInitialState } from 'src/store/initialState';

interface ISamsungResultProps {
  t?: any;
  samsungOrderInvoiceForm: IInitialState['samsungOrderInvoiceView']['samsungSearchForm'];
  samsungOrderInvoiceResults: any[][];
  pageInformation: any;
  userData: any;
  searchSamsungOrdersAndInvoices(request: any, paginationRequest: any): void;
  exportSamsungOrdersAndInvoices(request: any): void;
}

class SamsungOrderInvoiceResultTable extends React.Component<
  ISamsungResultProps,
  IInitialState
> {
  constructor(props: any) {
    super(props);
    this.handlePagination = this.handlePagination.bind(this);
    this.handlePageSizeChange = this.handlePageSizeChange.bind(this);
    this.handleExportIconClick = this.handleExportIconClick.bind(this);
  }

  public handleClose = () => {
    // this.setState({ samsungOrderInvoiceResults: []});
  };

  private handlePagination = (targetPageNumber: any) => {
    const paginationRequest = {
      page: targetPageNumber - 1,
      size: this.props.pageInformation.pageSize
    };
    this.props.searchSamsungOrdersAndInvoices(
      this.props.samsungOrderInvoiceForm,
      paginationRequest
    );
  };

  private handlePageSizeChange = (targetPageSize: any) => {
    const paginationRequest = {
      page: 0,
      size: targetPageSize
    };
    this.props.searchSamsungOrdersAndInvoices(
      this.props.samsungOrderInvoiceForm,
      paginationRequest
    );
  };

  public handleExportIconClick = () => {
    const samsungDownloadRequestForm = this.props.samsungOrderInvoiceForm;
    samsungDownloadRequestForm['userName'] = this.props.userData.clientIdentity;
    this.props.exportSamsungOrdersAndInvoices(samsungDownloadRequestForm);
  };

  public render() {
    const { t } = this.props;
    // const { portalData } = this.props;
    const columns = [
      `${t('samsungOrder.serviceTicket')}`,
      `${t('samsungOrder.rplAccount')}`,
      `${t('samsungOrder.ascAct')}`,
      `${t('samsungOrder.rplSalesOrder')}`,
      `${t('samsungOrder.customerPO')}`,
      `${t('samsungOrder.orderDate')}`,
      `${t('samsungOrder.shipDate')}`,
      `${t('samsungOrder.status')}`,
      `${t('samsungOrder.partNumber')}`,
      `${t('samsungOrder.description')}`,
      `${t('samsungOrder.orderQty')}`,
      `${t('samsungOrder.price')}`,
      `${t('samsungOrder.shippedQty')}`,
      `${t('samsungOrder.deliveryDate')}`,
      `${t('samsungOrder.tracking')}`,
      `${t('samsungOrder.rplInvoice')}`,
      `${t('samsungOrder.shipFromLoc')}`,
      `${t('samsungOrder.shipMethod')}`,
      `${t('samsungOrder.shipTo')}`,
      `${t('samsungOrder.city')}`,
      `${t('samsungOrder.serialNumber')}`,
      `${t('samsungOrder.coreNumber')}`
    ];

    const pageInfo = this.props.pageInformation;

    const options = {
      filter: false,
      search: false,
      pagination: false,
      print: false,
      viewColumns: false,
      download: false,
      customToolbar: () => (
        <MuiThemeProvider theme={theme}>
        <span
            className="export-icon download"
            onClick={this.handleExportIconClick}
          >
            <Button aria-controls="fade-menu" aria-haspopup="true">
              <img className="image-icon download-icon" src={downloadReceipt} />
              <img className="down-arrow" src={downarrowIcon} />
         </Button>
          </span> 
          <div className="rp-product-status--paginator">
            <CustomPaginator
              activePage={pageInfo.pageNumber + 1}
              totalPages={pageInfo.totalPages}
              itemsPerPage={pageInfo.pageSize}
              onPageChanged={this.handlePagination}
              totalItems={pageInfo.totalElements}
              showPageInfo={true}
              onPageSizeChange={this.handlePageSizeChange}
              showPageRangeChange={true}
              currentPageSize={pageInfo.pageSize}
            />
          </div>
        </MuiThemeProvider>
      )
    };

    const data = this.props.samsungOrderInvoiceResults;

    return (
      <div className="rp-samsungOrderInner">
        <React.Fragment>
          <MuiThemeProvider theme={theme}>
            <MUIDataTable
              title={''}
              data={data}
              columns={columns}
              options={options}
            />
          </MuiThemeProvider>
          <div className="rp-product-status--paginator">
            <CustomPaginator
              activePage={pageInfo.pageNumber + 1}
              totalPages={pageInfo.totalPages}
              itemsPerPage={pageInfo.pageSize}
              onPageChanged={this.handlePagination}
              totalItems={pageInfo.totalElements}
              showPageInfo={true}
              onPageSizeChange={this.handlePageSizeChange}
              showPageRangeChange={true}
              currentPageSize={pageInfo.pageSize}
            />
          </div>
        </React.Fragment>
      </div>
    );
  }
}

export default SamsungOrderInvoiceResultTable;
